"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Icons = tslib_1.__importStar(require("./icons"));
var size_1 = require("./icons/size");
function Icon(_a) {
    var _b = _a.name, name = _b === void 0 ? "ActionArchive01" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.color, color = _d === void 0 ? "currentColor" : _d;
    return (react_1.default.createElement(Icons[name], {
        strokeWidth: 2.4,
        color: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: {
            width: size_1.size[size || "medium"].width,
            height: size_1.size[size || "medium"].height,
            flexShrink: 0,
        },
    }) || react_1.default.createElement(react_1.default.Fragment, null));
}
exports.default = Icon;
//# sourceMappingURL=index.js.map